<template>
  <div class="dashboard">
    <b-container v-if="!isLoading">
      <b-row class="summary">
        <b-col md="8" class="left-summ">
          <h5>{{ labels.summary }}</h5>
          <h2>{{ documentsChartTotal + " " + labels.documents }}</h2>
          <div class="chart" v-if="documentsChartDays.length != 0">
            <div
              :class="[
                maxValuePosition == 4 ? 'active-bar' : '',
                'bar-' + documentsChartNumbers[4],
              ]"
              v-if="documentsChartDays.length > 4"
            >
              <span class="day-4">{{ documentsChartDays[4] }}</span>
            </div>
            <div
              :class="[
                maxValuePosition == 3 ? 'active-bar' : '',
                'bar-' + documentsChartNumbers[3],
              ]"
              v-if="documentsChartDays.length > 3"
            >
              <span class="day-3">{{ documentsChartDays[3] }}</span>
            </div>
            <div
              :class="[
                maxValuePosition == 2 ? 'active-bar' : '',
                'bar-' + documentsChartNumbers[2],
              ]"
              v-if="documentsChartDays.length > 2"
            >
              <span class="day-2">{{ documentsChartDays[2] }}</span>
            </div>
            <div
              :class="[
                maxValuePosition == 1 ? 'active-bar' : '',
                'bar-' + documentsChartNumbers[1],
              ]"
              v-if="documentsChartDays.length > 1"
            >
              <span class="day-1">{{ documentsChartDays[1] }}</span>
            </div>
            <div
              :class="[
                maxValuePosition == 0 ? 'active-bar' : '',
                'bar-' + documentsChartNumbers[0],
              ]"
              v-if="documentsChartDays.length > 0"
            >
              <span class="day-0">{{ documentsChartDays[0] }}</span>
            </div>
          </div>
          <div v-else>
            <h3>{{ labels.nodocuments }}</h3>
          </div>
        </b-col>
        <b-col md="4" class="right-summ">
          <div class="big-number">
            <h5>{{ labels.total }}</h5>
            <h1>{{ documentsTotal }}</h1>
            <span class="circle-1"></span>
            <span class="circle-2"></span>
          </div>
        </b-col>
      </b-row>
      <b-row class="others">
        <b-col lg="6" class="pr-lg-3">
          <div class="users">
            <h5>{{ labels.users }}</h5>
            <table>
              <tbody>
                <tr v-for="item in users" :key="item.id">
                  <td>{{ item.username }}</td>
                  <td v-if="item.enabled" class="user-active">
                    {{ labels.active }}
                  </td>
                  <td v-else class="user-inactive">{{ labels.inactive }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- <div class="providers">
            <div class="total-providers">
              <h6>{{labels.providers}}</h6>
              <h2>{{ trmCoffee }}</h2>
              <a href="https://www.larepublica.co/indicadores-economicos/commodities/cafe" target="_blank">{{labels.priceOrigin}}*</a>
            </div>
            <div class="icon">
              <font-awesome-icon :icon="['fas', 'globe-americas']" />
            </div>
          </div> -->
        </b-col>
        <b-col lg="6" class="pl-lg-3">
          <div class="last-documents">
            <h5>{{ labels.lastdocuments }}</h5>
            <table>
              <thead>
                <tr>
                  <th>{{ labels.provider }}</th>
                  <th>{{ labels.date }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in lastdocuments" :key="item.id">
                  <td>{{ item.username }}</td>
                  <td>{{ item.createdAt }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </b-col>
      </b-row>
    </b-container>

    <b-row v-else>
      <b-col md="12" lg="12" class="p-4 mx-audo">
        <div class="text-center">
          <b-spinner></b-spinner>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Company from "@/services/Company";
// import Provider from "@/services/Provider";
import User from "@/services/User";
// import Coffee from "@/services/Coffee";

export default {
  name: "List",

  data: () => ({
    currentSort: "createdAt",
    currentSortOrder: "asc",
    showDialog: false,
    dialogItem: {},
    inscriptions: [],
    searched: [],
    search: null,
    isEmpty: false,
    isUpdating: false,
    isLoading: false,
    success: false,
    error: false,
    users: [],
    documents: [],
    lastdocuments: [],
    providersTotal: 0,
    documentsChartTotal: 0,
    documentsChart: {},
    documentsChartNumbers: [],
    documentsChartDays: [],
    documentsTotal: 0,
    maxValuePosition: 0,
    trmCoffee: "US$ -.--",
  }),
  computed: {
    labels() {
      if (this.$store.state._language == "es-ES") {
        return {
          summary: "Resumen",
          documents: "Documentos",
          total: "Total",
          users: "Usuarios",
          active: "Activo",
          inactive: "Inactivo",
          providers: "TRM Café Hoy",
          priceOrigin: "Dato tomado de LaRepublica",
          lastdocuments: "Últimos documentos",
          provider: "Usuario",
          date: "Fecha",
          nodocuments: "Aún no hay documentos",
        };
      } else {
        return {
          summary: "Summary",
          documents: "documents",
          total: "Total",
          users: "Users",
          active: "Active",
          inactive: "Inactive",
          providers: "Providers Total",
          lastdocuments: "Last documents",
          provider: "Provider",
          date: "Date",
          nodocuments: "No documents Found",
        };
      }
    },
    role() {
      // console.log(this.$store.state.userRole)
      return this.$store.state.userRole;
    },
    pages() {
      return this.labels.pages.filter((page) => {
        return page.roles.find((item) => {
          return item === this.$store.state.userRole;
        });
      });
    },
  },
  methods: {},
  mounted() {
    this.isLoading = true;
    // Coffee.getLaRepublicaCoffeeTRM()
    // .then( fechedTRM => {
    //   console.log(fechedTRM)
    //   this.trmCoffee = fechedTRM.data[0].value
    // }).catch(() => {
    //       this.error = true;
    // });
    this.currentDay = new Date().getDate();
    Company.getAllCompanies()
      .then((fetchedData) => {
        this.documents = fetchedData.data.companies;
        this.documentsTotal = this.documents.length;
        if (this.documentsTotal > 6) {
          this.lastdocuments = this.documents.slice(0, 4);
        } else {
          this.lastdocuments = this.documents;
        }
        this.documents.forEach((element) => {
          if (element.createdAt.slice(0, 5) in this.documentsChart) {
            this.documentsChart[element.createdAt.slice(0, 5)] += 1;
          } else {
            this.documentsChart[element.createdAt.slice(0, 5)] = 1;
          }
        });
        this.documentsChartDays = Object.keys(this.documentsChart);
        this.documentsChartNumbers = Object.values(this.documentsChart);
        if (this.documentsChartDays.length > 5) {
          this.documentsChartDays = this.documentsChartDays.slice(0, 5);
          this.documentsChartNumbers = this.documentsChartNumbers.slice(0, 5);
        }
        this.maxValuePosition = this.documentsChartNumbers.indexOf(
          Math.max(...this.documentsChartNumbers)
        );
        this.documentsChartTotal = this.documentsChartNumbers.reduce(
          (a, b) => a + b,
          0
        );
        const maxValue = Math.max(...this.documentsChartNumbers);
        this.documentsChartNumbers = this.documentsChartNumbers.map((item) => {
          return Math.ceil((item * 10) / maxValue);
        });
        this.isLoading = false;

      })
      .catch(() => {
        this.error = true;
      });
    User.getAllUsers()
      .then((fetchedData) => {
        this.users = fetchedData.data.users;
        if (this.users.length > 4) {
          this.users = this.users.slice(0, 4);
        }
      })
      .catch(() => {
        this.error = true;
      })
      .finally(() => {
        this.isLoading = false;
      });
        // this.isLoading = false;

  },
};
</script>

<style src="../main.css"></style>
